var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('AboutHeader'),_c('AboutIntro'),_c('AboutBullets'),_c('AboutPromote'),_c('AboutTeam'),_c('AboutCharte'),_c('AboutHistory'),_c('NavigationCta')],1)}
var staticRenderFns = []

export { render, staticRenderFns }